import { QuestionInfo } from '../../Common/Models/Api/Info/DynamicForm/QuestionInfo';
import { Component, Input } from '@angular/core';
import { DynamicFormAnswer } from './DynamicFormAnswer';

@Component({
	standalone: false,
	selector: 'dfq-singlechoiceradio',
	template: /*language=html*/ `
		<h3>
			<span>{{ data.questionNumber }}</span> {{ data.Header }} <span class="required" *ngIf="data.Required">*</span>
		</h3>
		<div class="row input" [class.dirty]="dirty">
			<visiba-input
				[options]="options"
				type="radio"
				[(ngModel)]="radioModel"
				value="resourceId"
				(onChange)="valueChange()"
				[readonly]="readonly"
			></visiba-input>
			<span class="error" *ngIf="!valid()">{{ 'LicenceHolder.DynamicForm.Error.SingleChoiceRequired' | translate }}</span>
		</div>
	`,
})
export class DfqSingleChoiceRadioComponent {
	@Input() formId: number = null;
	@Input() data: QuestionInfo = null;
	@Input() readonly = false;
	options: Array<{ resourceId: number; value: boolean; label: string }> = [];
	dirty: boolean = false;
	radioModel: number = null;

	constructor() {}

	ngOnInit() {
		this.options = this.data.Options.map((x) => {
			return { resourceId: x.Id, value: false, label: x.Text };
		});
		if (typeof this.data.Answer === 'undefined' || this.data.Answer === null)
			this.data.Answer = new DynamicFormAnswer(null, this.data.Id, this.valid);
		else {
			this.data.Answer.Valid = this.valid;
			if (this.data.Answer.Choices.length > 0) this.radioModel = this.data.Answer.Choices[0];
		}
	}

	valueChange = () => {
		this.dirty = true;
		this.data.Answer.Choices = [this.radioModel];
	};

	valid = (): boolean => {
		return !this.data.Required || (typeof this.data.Answer.Choices !== 'undefined' && this.data.Answer.Choices.length > 0);
	};
}
